import {
  clearDashboardScrollState,
  readDashboardScrollState,
  saveDashboardScrollState,
} from "../../DashboardCourses/utils/exploreCoursesScrollRestore";

export const STUDY_DASHBOARD_SCROLL_SESSION_KEY = "motion.studyDashboardScroll";

export const getQuickActionAnchorId = (itemId) =>
  itemId != null ? `study-quick-action-${itemId}` : null;

export const getRecentTestAnchorId = (paperId) =>
  paperId != null ? `study-recent-test-${paperId}` : "study-recent-tests";

export const RECENT_TESTS_SECTION_ID = "study-recent-tests";

export const saveStudyDashboardScrollState = ({
  anchorId = null,
  pageIndex = 0,
} = {}) => {
  saveDashboardScrollState(STUDY_DASHBOARD_SCROLL_SESSION_KEY, {
    anchorId,
    pageIndex: Number.isFinite(pageIndex) ? Math.max(0, pageIndex) : 0,
  });
};

export const readStudyDashboardScrollState = () =>
  readDashboardScrollState(STUDY_DASHBOARD_SCROLL_SESSION_KEY);

export const clearStudyDashboardScrollState = () =>
  clearDashboardScrollState(STUDY_DASHBOARD_SCROLL_SESSION_KEY);
